// extracted by css-extract-rspack-plugin
export default {"rows":"MergeStatusRow-module__rows__jvL8R","row":"MergeStatusRow-module__row__guYKo"};